import api from './api';

export const transactionService = {
  getTransactions: async (page = 1, limit = 10) => {
    const skip = (page - 1) * limit;
    return api.get(`/balance/transactions?skip=${skip}&limit=${limit}`);
  }
}; 